import React from 'react';
import PropTypes from 'prop-types';
import { useCollapse } from "react-collapsed";
import { FormattedMessage } from 'react-intl';

import { Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Locale
import messages from '../../../locale/messages';
import { DownArrowIcon } from '../../Common/Assets/SvgComponent/SiteAdminSvgIcon';
import s from './FaqSection.css';
import t from '../../../styles/customReactCollapse.css'

const FaqItemList = (props) => {
  const { title, desc } = props;
  if (!title) return;
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
  return (
    <div className={cx('faqCollapseButtonContainer', isExpanded && 'faqCollapseButtonContainerOpen')}>
      <button {...getToggleProps()} className={cx('faqCollapseButton')}>
        {title}
        <DownArrowIcon />
      </button>
      <div {...getCollapseProps()} className={'faqCollapseBody'}>
        <div className={'faqCollapseBodyWrapper'}>
          {desc}
        </div>
      </div>
    </div>
  )
}

const FaqSection = ({ data }) => {
  return (
    <Grid className={cx("faqCollapseBox", s.container)}>
      <Row className={s.faqsection}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className={cx(s.mainhedding, 'mainheddingRTLMobile')}>
            <h1><FormattedMessage {...messages.faqtitle} /></h1>
            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <FaqItemList title={data?.faqTitle1} desc={data?.faqContent1} />
                <FaqItemList title={data.faqTitle3} desc={data.faqContent3} />
                <FaqItemList title={data?.faqTitle5} desc={data.faqContent5} />
                <FaqItemList title={data.faqTitle7} desc={data.faqContent7} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <FaqItemList title={data?.faqTitle2} desc={data?.faqContent2} />
                <FaqItemList title={data.faqTitle4} desc={data.faqContent4} />
                <FaqItemList title={data?.faqTitle6} desc={data.faqContent6} />
                <FaqItemList title={data.faqTitle8} desc={data.faqContent8} />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Grid>
  );
}

FaqSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default withStyles(s, t)(FaqSection);
